export default "__VITE_ASSET__5389b966__"